var _rect, _rect2, _rect3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicIconDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1223_17793)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#49943E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1223_17793",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 24,
    height: 24
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1223_17793)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 22C19.1667 22 18.4583 21.7083 17.875 21.125C17.2917 20.5417 17 19.8333 17 19V13C17 12.1667 17.2917 11.4583 17.875 10.875C18.4583 10.2917 19.1667 10 20 10C20.8333 10 21.5417 10.2917 22.125 10.875C22.7083 11.4583 23 12.1667 23 13V19C23 19.8333 22.7083 20.5417 22.125 21.125C21.5417 21.7083 20.8333 22 20 22ZM19 29V25.925C17.2667 25.6917 15.8333 24.9167 14.7 23.6C13.5667 22.2833 13 20.75 13 19H15C15 20.3833 15.4875 21.5625 16.4625 22.5375C17.4375 23.5125 18.6167 24 20 24C21.3833 24 22.5625 23.5125 23.5375 22.5375C24.5125 21.5625 25 20.3833 25 19H27C27 20.75 26.4333 22.2833 25.3 23.6C24.1667 24.9167 22.7333 25.6917 21 25.925V29H19Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1223_17793"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicIconDark);
export default __webpack_public_path__ + "static/media/mic-icon-dark.17d85afdf0a3ed0910395c3389eff8b7.svg";
export { ForwardRef as ReactComponent };